    export const isMobile = /iPhone|Android/i.test(navigator.userAgent);
// export const isMobile = true;